import { useAuth0 } from '@auth0/auth0-react';
import { LogoutRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <Button
      aria-label="logout"
      startIcon={<LogoutRounded />}
      sx={{ mr: 1, color: 'text.primary' }}
      onClick={() => logout({ returnTo: window.location.origin })}
    >
      Sign out
    </Button>
  );
};

export default LogoutButton;
